module.exports = __webpack_public_path__ + "img/pic-logo-wq.31bc2c2c.png";